"use client";

import React from 'react';

export default function Loading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <div className="relative flex flex-col items-center">
        {/* Skeleton loader for logo */}
        <div className="w-32 h-12 bg-slate-200 animate-pulse rounded mb-6"></div>
        
        {/* Skeleton loaders for content */}
        <div className="w-3/4 max-w-2xl mx-auto">
          <div className="h-8 bg-slate-200 animate-pulse rounded-lg mb-4 w-2/3 mx-auto"></div>
          <div className="h-4 bg-slate-200 animate-pulse rounded mb-2 w-full"></div>
          <div className="h-4 bg-slate-200 animate-pulse rounded mb-2 w-5/6"></div>
          <div className="h-4 bg-slate-200 animate-pulse rounded mb-8 w-4/6"></div>
          
          <div className="aspect-video w-full bg-slate-200 animate-pulse rounded-lg mb-8"></div>
          
          <div className="h-10 bg-slate-200 animate-pulse rounded-lg w-40 mx-auto"></div>
        </div>
        
        <div className="absolute bottom-0 left-0 w-full h-1 overflow-hidden">
          <div className="h-full bg-gradient-to-r from-[#32a895] to-[#1f7ac3] animate-loader"></div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes loader {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .animate-loader {
          animation: loader 1.5s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
} 